import GridTableCellBase from '../../../ui_components/gridTable/GridTableCell';
import GridTableRowBase from '../../../ui_components/gridTable/GridTableRow';
import React, { FC, useState } from 'react';
import styled, { css } from '../../../theme';
import { FaEllipsisV } from 'react-icons/fa';
import { AvatarImage } from '../avatar';
import CopyToClipboard from '../copy-to-clipboard';
import { SortTableRowInfo } from './sort_table';
import EyeIcon from '../../../assets/icons/eye.svg';
import Pencil from '../../../assets/icons/pencil.svg';
import PlusIcon from '../../../assets/icons/add.svg';
// import ArrowDown from '../../../assets/icons/chevron-right.svg'
import ArrowDown from '../../../assets/icons/chevron-down.svg';
import { DotMenuState } from '../../../pages/clients';

const RowE: FC<RowProps> = (props) => (
  <GridTableRowBase className={props.className} onClick={props.onClick}>
    {props.children}
  </GridTableRowBase>
);

const Row = styled(RowE)`
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr 50px !important;
  grid-template-rows: auto !important;
  grid-column-gap: 0 !important;
  border-bottom: solid #e2e2e2 1px !important;
  padding: 0 !important;
  color: #000 !important;
  font-size: 14px !important;
  font-weight: 400 !important;

  &:last-child {
    border: 0 !important;
  }

  &:hover {
    background-color: #eee !important;
  }

  ${(props) =>
    props.italic &&
    css`
      color: #aaa !important;
      font-style: italic !important;
    `};
  cursor: auto !important;
`;

const BasicGridTableCell = styled(GridTableCellBase)`
  text-align: left !important;
  display: flex !important;
  align-items: center !important;
  padding: 10px 10px !important;
  font-weight: 400 !important;
  //border-left: 1px solid #e2e2e2;

  &:first-child {
    border-left: none !important;
  }
`;

const DisplayNameE: FC<LevelProps> = (props) => (
  <BasicGridTableCell className={props.className}>
    {props.children}
  </BasicGridTableCell>
);

const DisplayName = styled(DisplayNameE)<LevelProps>`
  text-align: left !important;
  padding-left: ${(props) => props.level * 34 + 10}px !important;
  color: #2d778c !important;
  font-weight: 500 !important;
  text-decoration: underline !important;
  overflow: hidden !important;
  & .dropdown_arrow {
    width: 24px !important;
    height: 100% !important;

    & .dropdown_arrow_position {
      width: 24px !important;
      transform: rotate(0deg) !important;
      transition: all 0.15s ease !important;

      &.active {
        transform: rotate(90deg) !important;
      }
    }
  }
`;

const Email = styled(BasicGridTableCell)`
  overflow: unset !important;
  white-space: normal !important;
`;

const BillingType = styled(BasicGridTableCell)`
    overflow: unset !important;
    white-space: normal !important;
`;
const Projects = styled(BasicGridTableCell)`
  color: #2d778c !important;
  text-decoration: underline !important;
  overflow: unset !important;
  white-space: normal !important;
  width: max-content !important;
  cursor: pointer !important;
`;

const Avatar = styled(AvatarImage)`
  margin-right: 8px !important;
  margin-left: 8px !important;
`;

export interface RowProps {
  className?: string;
  italic?: boolean;
  children?: React.ReactNode;
  onClick?(): void;
}

export interface LevelProps {
  level: number;
  className?: string;
  children?: React.ReactNode;
}

export interface SortTableRowProps extends LevelProps {
  data: SortTableRowInfo;
  onChoosed(id: number): void;
  handleToggle?(item: any): void;
  isActiveIndex?: boolean;
  handleShowDotMenu?(data: any): void;
  dotMenu?: DotMenuState;
  handleDotMenuAction?(action: string, client: any): void;
}

const SortTableRow: FC<SortTableRowProps> = (props) => {
  const { data, dotMenu, handleShowDotMenu, handleDotMenuAction } = props;
  const [disabled, setDisabled] = useState<boolean>(false);

  return (
    <Row italic={!props.data.active} className={`grid-table-row`}>
      <DisplayName className={props.className} level={props.level}>
        <div
          className="flex items-center justify-center dropdown_arrow"
          onMouseOut={() => setDisabled(false)}
          onMouseOver={() => setDisabled(true)}
          onClick={() => {
            if (props.handleToggle) props.handleToggle(props.data);
          }}
        >
          {props.data.subList && props.data.subList.length > 0 && (
            <ArrowDown
              className={`dropdown_arrow_position cursor-pointer ${props.isActiveIndex ? 'active' : ''}`}
            />
          )}
        </div>
        <Avatar
          avatarId={props.data.avatarId}
          firstName={props.data.firstName}
          lastName={props.data.lastName}
          companyName={props.data.companyName}
          width={28}
          height={28}
          fontSize={15}
        />
        <span
          data-qa={`clients-row-open-${props.data.id}`}
          className="cursor-pointer"
          onClick={() => {
            if (!disabled) {
              props.onChoosed(props.data.id);
            }
          }}
        >
          {props.data.displayName}
        </span>
        {!props.data.active && ' (Inactive)'}
      </DisplayName>
      <BillingType className={props.className}>{props.data.billingType}</BillingType>
      <Email>
        {props.data.email && props.data.email && (
          <CopyToClipboard
            title={props.data.email}
            copy={props.data.email}
            tooltipMessage="Email Copied"
          />
        )}
      </Email>

      <BasicGridTableCell>
        {props.data.cellPhone && props.data.cellPhone}
        {props.data.homePhone &&
          !props.data.cellPhone &&
          props.data.homePhone &&
          props.data.homePhone}
        {props.data.officePhone &&
          !props.data.cellPhone &&
          !props.data.homePhone &&
          props.data.officePhone &&
          props.data.officePhone}
      </BasicGridTableCell>
      <Projects
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          if (
            props.data.subList &&
            props.data.subList.length > 0 &&
            props.data.projectsCount &&
            props.data.projectsCount > 0
          ) {
            location.href = `projects?clientId=${props.data.id}`;
          } else if (props && props.data) {
            location.href = `clients/${props.data.id}`;
          }
        }}
      >
        {props.data.subList &&
        props.data.subList.length > 0 &&
        props.data.projectsCount &&
        props.data.projectsCount > 0
          ? `View All (${props.data.projectsCount})`
          : props.data.projectsCount && props.data.projectsCount > 0
          ? 'View Project'
          : ''}
      </Projects>

      <div
        onMouseOut={() => setDisabled(false)}
        onMouseOver={() => setDisabled(true)}
        className="client_table_cell"
      >
        <button
          type="button"
          onClick={() => {
            if (handleShowDotMenu) {
              handleShowDotMenu(data);
            }
          }}
        >
          <FaEllipsisV />
        </button>

        {dotMenu && dotMenu.active && dotMenu.rowId === data.id && (
          <div className="dots_menu">
            <div
              className="dots_menu_row"
              onClick={() => {
                if (handleDotMenuAction) {
                  handleDotMenuAction('view', data);
                }
              }}
            >
              <EyeIcon />
              <span>View Client Profile</span>
            </div>

            <div
              className="dots_menu_row"
              onClick={() => {
                if (handleDotMenuAction) {
                  handleDotMenuAction('edit', data);
                }
              }}
            >
              <Pencil />
              <span>Edit Client Profile</span>
            </div>

            <div
              className="dots_menu_row"
              onClick={() => {
                if (handleDotMenuAction) {
                  handleDotMenuAction('add_sub_client', data);
                }
              }}
            >
              <PlusIcon className="plus_icon" style={{ width: '18px', height: '18px' }} />
              <span>Add Sub-Client</span>
            </div>
          </div>
        )}
      </div>
    </Row>
  );
};

export default SortTableRow;
